import loadable from '@loadable/component';

import { createRouter } from '@/utils/router';

import App from './App';

export default createRouter({
  getComponent: () => App,
  onEnter: (nextState, history) => {
    const { match } = nextState;
    const isMatch = match && match.isExact;
    if (isMatch) {
      history.replace('/home');
    }
  },
  getChildRoutes: () => [
    {
      path: '/home',
      component: loadable(() => import('./home'))
    },
    {
      component: loadable(() => import('./404'))
    }
  ]
});
